import { useState } from "react";
import { X, Copy, Check, MessageCircle, Share2 } from "lucide-react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export default function ShareReelSheet({ reel, onClose }) {
    const [copied, setCopied] = useState(false);
    const shareUrl = `${window.location.origin}/reels/${reel.id}`;
    const p = reel.property || {};
    const shareText = `Check out this property on Global Property Mart: ${p.title || "Property"}${p.city ? ` in ${p.city}` : ""}`;

    const track = (channel) => {
        api.post(`/reels/${reel.id}/share`, { channel }).catch(() => {});
    };

    const copyLink = async () => {
        try {
            await navigator.clipboard.writeText(shareUrl);
            setCopied(true);
            track("copy_link");
            toast.success("Link copied");
            setTimeout(() => setCopied(false), 1500);
        } catch {
            toast.error("Could not copy link");
        }
    };

    const shareNative = async () => {
        if (!navigator.share) {
            copyLink();
            return;
        }
        try {
            await navigator.share({ title: p.title || "GPM Reel", text: shareText, url: shareUrl });
            track("native");
        } catch {
            // user cancelled — ignore
        }
    };

    const shareWhatsApp = () => {
        const url = `https://wa.me/?text=${encodeURIComponent(`${shareText}\n${shareUrl}`)}`;
        window.open(url, "_blank", "noopener");
        track("whatsapp");
    };

    return (
        <div className="fixed inset-0 z-40 flex items-end" style={{ background: "rgba(0,0,0,0.65)" }}
             onClick={onClose} data-testid="reel-share-sheet">
            <div className="w-full bg-white rounded-t-2xl p-4" onClick={(e) => e.stopPropagation()}>
                <div className="flex items-center justify-between mb-3">
                    <div className="font-heading font-extrabold text-[14px]" style={{ color: "#002657" }}>Share this Reel</div>
                    <button onClick={onClose} className="w-8 h-8 rounded-full flex items-center justify-center"
                            style={{ background: "#f4f4f5" }} data-testid="reel-share-close">
                        <X className="w-4 h-4" />
                    </button>
                </div>
                <div className="rounded-lg p-2 bg-cream-50 text-[11.5px] break-all mb-3 border"
                     style={{ background: "#FBF6E0", borderColor: "rgba(218,165,32,0.3)", color: "#8B6712" }}>
                    {shareUrl}
                </div>
                <div className="grid grid-cols-3 gap-2">
                    <button onClick={shareWhatsApp} data-testid="reel-share-whatsapp"
                        className="flex flex-col items-center gap-1 py-3 rounded-xl border"
                        style={{ borderColor: "rgba(0,38,87,0.08)" }}>
                        <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ background: "#25D366" }}>
                            <MessageCircle className="w-5 h-5 text-white" />
                        </div>
                        <span className="text-[11px] font-bold" style={{ color: "#002657" }}>WhatsApp</span>
                    </button>
                    <button onClick={copyLink} data-testid="reel-share-copy"
                        className="flex flex-col items-center gap-1 py-3 rounded-xl border"
                        style={{ borderColor: "rgba(0,38,87,0.08)" }}>
                        <div className="w-10 h-10 rounded-full flex items-center justify-center"
                             style={{ background: "linear-gradient(135deg, #001a3d, #002657)" }}>
                            {copied ? <Check className="w-5 h-5 text-white" /> : <Copy className="w-5 h-5 text-white" />}
                        </div>
                        <span className="text-[11px] font-bold" style={{ color: "#002657" }}>{copied ? "Copied" : "Copy Link"}</span>
                    </button>
                    <button onClick={shareNative} data-testid="reel-share-native"
                        className="flex flex-col items-center gap-1 py-3 rounded-xl border"
                        style={{ borderColor: "rgba(0,38,87,0.08)" }}>
                        <div className="w-10 h-10 rounded-full flex items-center justify-center"
                             style={{ background: "linear-gradient(135deg, #DAA520, #F59E0B)" }}>
                            <Share2 className="w-5 h-5" style={{ color: "#001a3d" }} />
                        </div>
                        <span className="text-[11px] font-bold" style={{ color: "#002657" }}>Share…</span>
                    </button>
                </div>
            </div>
        </div>
    );
}
